// extracted by mini-css-extract-plugin
export default {"modal":"modal___dfLya","waitingContainer":"waitingContainer___zzk6J","waitingIcon":"waitingIcon___SPENl","tipText":"tipText___YwBZh"};